/* KOJI HEADER MENU - logica isola Esplora (mobile + desktop): apri/chiudi, swipe, a11y, spedizione gratuita, avatar */
(function () {
  'use strict';

  var OPEN_CLASS = 'koji-menu-open';
  var root = document.documentElement;

  function init() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.koji-menu-trigger'));
    var panel = document.getElementById('koji-menu-panel');
    var scrim = document.getElementById('koji-menu-scrim');
    var menu = document.getElementById('koji-menu');
    if (!triggers.length || !panel || !scrim || !menu) return;

    var ship = document.getElementById('koji-menu-ship');
    var shipText = document.getElementById('koji-menu-ship-text');
    var shipFill = document.getElementById('koji-menu-ship-fill');
    var threshold = ship ? (parseInt(ship.getAttribute('data-threshold'), 10) || 4999) : 4999;
    var isOpen = false;
    var lastTrigger = triggers[0];

    /* ---------- Avatar utente (stessa regola dell'header: localStorage koji_avatar_url_<email>) ---------- */
    function applyAvatar() {
      var wrapper = document.querySelector('.koji-header-pro-wrapper');
      var holder = panel.querySelector('.koji-menu-account-ic');
      if (!wrapper || !holder) return;
      var email = wrapper.getAttribute('data-customer-email');
      if (!email) return;
      var url = null;
      try { url = localStorage.getItem('koji_avatar_url_' + email); } catch (err) {}
      var img = holder.querySelector('.koji-menu-avatar');
      var icon = holder.querySelector('svg');
      if (url) {
        if (!img) {
          img = document.createElement('img');
          img.className = 'koji-menu-avatar';
          img.alt = '';
          img.width = 40;
          img.height = 40;
          img.setAttribute('aria-hidden', 'true');
          img.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;border-radius:inherit;';
          holder.appendChild(img);
        }
        if (img.getAttribute('src') !== url) img.src = url;
        img.style.display = 'block';
        if (icon) icon.style.display = 'none';
        holder.style.overflow = 'hidden';
        holder.style.padding = '0';
      } else {
        if (img) img.style.display = 'none';
        if (icon) icon.style.display = '';
      }
    }

    /* ---------- Spedizione gratuita ---------- */
    function euro(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',').replace(',00', '');
    }

    function renderShip(cart) {
      if (!ship || !shipText || !shipFill || !cart) return;
      var total = cart.total_price || 0;
      var done = total >= threshold;
      shipFill.style.setProperty('--p', Math.min(100, (total / threshold) * 100) + '%');
      ship.classList.toggle('is-done', done);
      if (done) {
        shipText.textContent = '🎉 Spedizione gratuita attiva!';
      } else if (!cart.item_count) {
        shipText.innerHTML = 'Spedizione gratuita da <b>' + euro(threshold) + '</b>';
      } else {
        shipText.innerHTML = 'Ti mancano <b>' + euro(threshold - total) + '</b> per la spedizione gratuita';
      }
    }

    function refreshShip() {
      if (!ship) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(renderShip)
        .catch(function () {});
    }

    /* ---------- Apri / chiudi ---------- */
    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])'));
    }

    function visibleTrigger() {
      if (lastTrigger && lastTrigger.offsetParent !== null) return lastTrigger;
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].offsetParent !== null) return triggers[i];
      }
      return triggers[0];
    }

    function setOpen(next, restoreFocus) {
      if (next === isOpen) return;
      isOpen = next;
      root.classList.toggle(OPEN_CLASS, next);
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', next ? 'true' : 'false');
        t.setAttribute('aria-label', next ? 'Chiudi menu' : 'Apri menu');
      });
      panel.setAttribute('aria-hidden', next ? 'false' : 'true');
      if (next) {
        panel.removeAttribute('inert');
        applyAvatar();
        refreshShip();
        window.requestAnimationFrame(function () { panel.focus({ preventScroll: true }); });
      } else {
        panel.setAttribute('inert', '');
        if (restoreFocus) visibleTrigger().focus({ preventScroll: true });
      }
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        lastTrigger = t;
        setOpen(!isOpen, true);
      });
    });

    scrim.addEventListener('click', function () { setOpen(false, true); });
    scrim.addEventListener('touchmove', function (e) {
      if (e.cancelable) e.preventDefault();
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        setOpen(false, true);
        return;
      }
      if (e.key === 'Tab') {
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        var active = document.activeElement;
        if (e.shiftKey && (active === first || active === panel)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* ---------- Swipe verso il basso per chiudere (mobile) ---------- */
    var startY = 0;
    var dy = 0;
    var dragging = false;

    function resetDrag() {
      panel.style.transition = '';
      panel.style.transform = '';
    }

    panel.addEventListener('touchstart', function (e) {
      if (!isOpen) return;
      startY = e.touches[0].clientY;
      dy = 0;
      dragging = panel.scrollTop <= 0;
    }, { passive: true });

    panel.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dy = e.touches[0].clientY - startY;
      if (dy > 0 && panel.scrollTop <= 0) {
        if (e.cancelable) e.preventDefault();
        panel.style.transition = 'none';
        panel.style.transform = 'translateY(' + dy * 0.9 + 'px)';
      }
    }, { passive: false });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      var shouldClose = dy > 90;
      dy = 0;
      resetDrag();
      if (shouldClose) setOpen(false, false);
    }
    panel.addEventListener('touchend', endDrag, { passive: true });
    panel.addEventListener('touchcancel', endDrag, { passive: true });

    /* Il pull-to-refresh del tema ascolta i touch sulla window: dentro al menu lo fermiamo */
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (type) {
      menu.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
    });

    /* ---------- Casi particolari ---------- */
    /* Cambio di layout (mobile <-> desktop): richiudi il menu */
    var mq = window.matchMedia('(min-width: 990px)');
    function onBreakpoint() { setOpen(false, false); }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);

    /* Navigazione e tasto indietro (bfcache): il menu non deve restare aperto con lo scroll bloccato */
    window.addEventListener('pagehide', function () { setOpen(false, false); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        resetDrag();
        setOpen(false, false);
        applyAvatar();
      }
    });

    /* Carrello aggiornato altrove: tieni allineata la barra spedizione */
    window.addEventListener('cart:updated', refreshShip);
    document.addEventListener('ajaxProduct:added', refreshShip);

    /* Avatar cambiato in un'altra scheda */
    window.addEventListener('storage', function (e) {
      if (e.key && e.key.indexOf('koji_avatar_url_') === 0) applyAvatar();
    });

    applyAvatar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================
   Barra pillole desktop: se non c'e abbastanza spazio per icone + testo,
   le pillole passano da sole alla versione "solo icona" (classe koji-nav-compact),
   cosi non vengono mai tagliate ai lati. Il calcolo usa la larghezza naturale
   delle pillole, quindi non dipende da scroll o animazioni in corso.
   ========================================================= */
(function () {
  'use strict';

  var css = '@media (min-width: 990px) {' +
    '.koji-header-pro-wrapper .koji-desk-nav { min-width: 0; justify-content: safe center; }' +
    '.koji-header-pro-wrapper.koji-nav-compact .koji-pill-text { max-width: 0 !important; margin-left: 0 !important; opacity: 0 !important; }' +
    '.koji-header-pro-wrapper.koji-nav-compact .koji-desk-pill { padding: 10px; }' +
    '}' +
    '@media (min-width: 990px) and (max-width: 1100px) {' +
    '.koji-header-pro-wrapper .koji-desk-nav { gap: 8px; }' +
    '}';
  var st = document.createElement('style');
  st.setAttribute('data-koji-nav-fit', '');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);

  var mqDesk = window.matchMedia('(min-width: 990px)');
  var queued = false;

  function fit() {
    queued = false;
    var nav = document.querySelector('.koji-desk-nav');
    var wrap = nav && nav.closest('.koji-header-pro-wrapper');
    if (!nav || !wrap) return;
    if (!mqDesk.matches) { wrap.classList.remove('koji-nav-compact'); return; }
    var gap = parseFloat(getComputedStyle(nav).columnGap) || 12;
    var need = 0;
    var count = 0;
    Array.prototype.forEach.call(nav.children, function (p) {
      if (getComputedStyle(p).display === 'none') return;
      var t = p.querySelector('.koji-pill-text');
      var ic = p.querySelector('.koji-pill-icon');
      var tw = t ? t.scrollWidth : 0;
      need += 34 + (ic ? ic.offsetWidth : 0) + (tw ? 8 + tw : 0); /* padding 16+16, bordo 1+1 */
      count++;
    });
    need += gap * Math.max(0, count - 1) + 4;
    wrap.classList.toggle('koji-nav-compact', need > nav.clientWidth);
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(fit);
  }

  function start() {
    fit();
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    window.addEventListener('pageshow', queue);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    var nav = document.querySelector('.koji-desk-nav');
    if (nav && window.ResizeObserver) new ResizeObserver(queue).observe(nav);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
